var map = {
	"./active-entity.js": "./src/selectors/document/active-entity.js",
	"./code-blocks.js": "./src/selectors/document/code-blocks.js",
	"./entity.js": "./src/selectors/document/entity.js",
	"./links.js": "./src/selectors/document/links.js",
	"./tree.js": "./src/selectors/document/tree.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;



//////////////////
// WEBPACK FOOTER
// ./src/selectors/document \.js$
// module id = 72
// module chunks = 0 1 2 3 4 5 6 7 10 11